<template>
  <section class="networksGuidelines">
    <div class="mb-3">Follow these guidelines when editing to ensure formatting is correct:</div>
    <div>
      <ul>
        <li>The unique triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” acts jointly as the <strong>unique ID</strong> per network.</li>
        <li>A new unique triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” will <strong>create</strong> a new network.</li>
        <li>An existing triple combination of “NetworkIP”, “NetworkName”, and “NetworkRange” will <strong>update</strong> that existing network.</li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name: 'networksSteps',
}
</script>
<style lang="scss" scoped>
</style>
